module.exports = __webpack_public_path__ + "img/empty.04ce2a0b.png";